import React from 'react';
import Remarkable from 'react-remarkable';

const Markdown = ({ text, ...props }) => {
  return <Remarkable {...props}>{text}</Remarkable>;
};

export default Markdown;
